import { getBrands } from '../../../../apis';
import { Brand } from '../../../../types/Brand';

export interface AutocompleteBrand {
  title: string;
  subtitle?: string;
}

// Cache brands per page load (shared across all components)
let brandsCache: Brand[] | null = null;
let brandsCachePromise: Promise<Brand[]> | null = null;

export const getCachedBrands = (): Promise<Brand[]> => {
  if (brandsCache) {
    return Promise.resolve(brandsCache);
  }
  if (brandsCachePromise) {
    return brandsCachePromise;
  }
  brandsCachePromise = getBrands()
    .then(brands => {
      brandsCache = brands;
      brandsCachePromise = null;
      return brands;
    })
    .catch(err => {
      brandsCachePromise = null;
      throw err;
    });
  return brandsCachePromise;
};

export const convertBrandsToAutocompleteBrands = (brands: Brand[]): AutocompleteBrand[] => {
  return brands.map(brand => ({
    title: brand.name,
    subtitle: brand.uuid,
  }));
};
